import React from 'react';
import {SafeAreaView, View} from 'react-native';

import sy from '~/styles';

import styles from './styles';
import {Link, Text} from '~/components/controls';
import PublicContentView from '~/components/shared/PublicContentView';

import configuration from '~/configuration';

const Error = ({navigation}) => {
  return (
    <SafeAreaView style={sy.mainView}>
      {configuration.production && (
        <>
          <View style={sy.headerView}>
            <Text style={sy.headerText}>Oeps!</Text>
          </View>
          <PublicContentView>
            <View style={sy.contentView}>
              <Text
                style={{
                  paddingHorizontal: 20,
                  paddingVertical: 20,
                }}>
                Pagina is niet gevonden
              </Text>
            </View>
          </PublicContentView>
        </>
      )}
      {!configuration.production && (
        <>
          <View style={sy.headerView}>
            <Text style={sy.headerText}>Development</Text>
          </View>
          <View style={styles.article}>
            <View style={styles.articleHeader}>
              <Text style={sy.mediumPlus}>Selecteer een dealer</Text>
            </View>
            <View style={styles.list}>
              <View style={styles.row}>
                <Text>Bahnkick Demo</Text>
                <Link
                  onPress={() =>
                    navigation.replace('Booking', {
                      screen: 'Intro',
                      params: {
                        dealer_id: '1d7f477c-2a35-4ff2-84f5-a1e87208d37a',
                      },
                    })
                  }>
                  Link
                </Link>
              </View>
              <View style={styles.row}>
                <Text>JAMES Autoservice Lisserbroek</Text>
                <Link
                  onPress={() =>
                    navigation.replace('Booking', {
                      screen: 'Intro',
                      params: {
                        dealer_id: 'c53565db-151a-49df-846e-6430802ab759',
                      },
                    })
                  }>
                  Link
                </Link>
              </View>
            </View>
          </View>
        </>
      )}
    </SafeAreaView>
  );
};

export default Error;
